import { Container } from 'blaskontrol';
export const diContainer = new Container();
